<template>
  <div class="tw-relative tw-flex tw-flex-col tw-gap-[12px]">
    <label
      v-if="title"
      class="tw-text-body-bold-mobile apTablet2:tw-text-body-bold-desktop"
      :class="{
        '!tw-text-ap-nero': isForcelightMode,
      }"
    >{{ title }}</label>
    <div>
      <input
        type="text"
        :class="[
          'tw-w-full apDesktop:tw-h-16 tw-h-12',
          'tw-outline tw-outline-offset-[-2px] tw-outline-1 tw-outline-ap-gainsboro ',
          'focus:tw-outline-ap-dodger-blue focus:tw-outline-2',
          'apDesktop:tw-rounded-xl tw-rounded-[10px] tw-bg-white tw-text-body-md-mobile-contact apTablet2:tw-text-body-md-desktop',
          'tw-px-6 tw-py-4',
          'tw-text-ap-nero placeholder:tw-text-ap-nobel apDesktop:placeholder:tw-text-body-desktop placeholder:tw-text-body-mobile',
          { '!tw-outline-ap-gainsboro !tw-bg-white !tw-text-ap-nero': isForcelightMode },
        ]"
        :value="data"
        :placeholder="placeholder"
        @input="updateData"
      >
    </div>
    <span
      :class="[
        'tw-absolute tw-bottom-[-32px] tw-left-0 tw-text-red-500 tw-text-base tw-mt-2 tw-z-50',
        'tw-transition-opacity tw-duration-300',
        { '!tw-opacity-0': !errorMsg }
      ]"
    >
      {{ errorMsg }}
    </span>
  </div>
</template>

<script setup lang="ts">

defineProps({
  title: {
    type: String,
    required: false
  },
  data: String,
  placeholder: String,
  errorMsg: {
    type: String,
    required: false, // Mark as optional
    default: null,   // Default value for when the prop is not provided
  },
  isForcelightMode: {
    type: Boolean,
    required: false,
    default: false,
  }
});

const emit = defineEmits(['update:data']);
function updateData(event: Event) {
  emit('update:data', (event.target as HTMLInputElement).value);
}

</script>